module.exports = __webpack_public_path__ + "static/img/jiaoxuesheji.664b58ad.png";